import { store } from "@/plugins/vuexconfig";
import { _axios } from "@/plugins/axiosconfig";
import { createApp } from "vue";
import VueAxios from "vue-axios";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "../quasar-user-options";
import { messages } from "@/messages";
import { createI18n } from "vue-i18n";
import H2OAnalyticsEntrypoint from "@/H2OAnalyticsEntrypoint.vue";
import { router } from "@/plugins/routerconfig";

console.info("main.js entry");

const h2o_analytics = createApp(H2OAnalyticsEntrypoint);

h2o_analytics.use(VueAxios, _axios);
h2o_analytics.use(store);
h2o_analytics.use(Quasar, quasarUserOptions);
h2o_analytics.use(
  createI18n({
    locale: "en_US",
    fallbackLocale: "en_US",
    messages,
  })
);

h2o_analytics.use(router);

h2o_analytics.mount("#app");
